import { Button } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { TextInput, required, useNotify, useRefresh, useUnselectAll } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const DeclineReasonModal = ({ stage, ids, resource, triggerLabel, iconOnly = false }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const unselectAll = useUnselectAll(resource);

  const handleConfirm = async data => {
    await dataProvider.customRequest(stage.declineUrl, { ids, reason: data.reason }, "POST");
    notify(`Отхвърлени записи: ${ids.length}`, { type: "success" });
    refresh();
    unselectAll();
  };

  return (
    <FormModal
      titleContent="Отхвърляне"
      saveTitle="Отхвърли"
      dialogSize="sm"
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          variant={iconOnly ? "text" : "contained"}
          color="error"
          size="small"
          disabled={!ids?.length}
          startIcon={<CancelIcon />}
        >
          {iconOnly ? "" : triggerLabel}
        </Button>
      }
    >
      <TextInput
        label="Причина за отхвърляне"
        source="reason"
        validate={[required()]}
        multiline
        minRows={3}
        fullWidth
      />
    </FormModal>
  );
};

export default DeclineReasonModal;
